import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('sdb-player-overlay-element')
class SdbPlayerOverlayElement extends LitElement {

    constructor() {
        super();
        this.container = null;
    }

    close() {
        this.container.removeChild(this);
    }

    render() {
        return html`
            <div
                @close-overlay=${() => { this.close(); }}>
                <slot></slot>
            </div>
        `;
    }

    firstUpdated() {
        let container = document.getElementById('player_overlay_container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'player_overlay_container';
            document.body.appendChild(container);
        }

        if (this.id) {
            const previouslyAttachedThis = container.querySelector(`#${this.id}`);
            if (previouslyAttachedThis) {
                container.removeChild(previouslyAttachedThis);
            }
        }

        this.container = container;
        this.container.appendChild(this);
    }
}

